// orp-calculator.js - Shopify App Backend Code
function calcORP(poolDetails = false, ORP = false, FreeChlorine = false, agent = '') {
  console.log(poolDetails);
  // Validate input
  if (!poolDetails || !poolDetails.poolVolume || !poolDetails.chlorineType) {
    return false;
  }

  // Dosage lookup table (same as PHP version)
  const dosageCalc = {
    1000: {
      0: ['0.25', '250'],
      1: ['0.25', '200']
    },
    10000: {
      0: ['0.25', '250'],
      1: ['0.25', '200']
    },
    20000: {
      0: ['0.5', '350'],
      1: ['0.5', '300']
    },
    30000: {
      0: ['0.5', '500'],
      1: ['0.5', '500']
    },
    40000: {
      0: ['0.75', '700'],
      1: ['0.75', '600']
    },
    50000: {
      0: ['1', '900'],
      1: ['0.75', '750']
    },
    60000: {
      0: ['1', '1000'],
      1: ['1', '1000']
    },
    70000: {
      0: ['1.25', '1250'],
      1: ['1', '1000']
    },
    80000: {
      0: ['1.5', '1500'],
      1: ['1.25', '1250']
    },
    90000: {
      0: ['1.75', '1750'],
      1: ['1.5', '1500']
    },
    100000: {
      0: ['2', '2000'],
      1: ['1.5', '1500']
    }
  };

  if (!dosageCalc[poolDetails.poolVolume]) {
    return false;
  }

  // Default values
  const idealRangeText = {
    PPM: "<br><b><small> (Ideal Range is 1 - 3 ppm)</small></b>",
    ORP: "<br><b><small> (Ideal Range is 500-700 mV)</small></b>"
  };

  let dosetype = 'cups Granular Chlorine';
  let doseCalcKey = 0;
  let ExtraInfo = '';

  if (poolDetails.chlorineType === 'Liquid Chlorine') {
    dosetype = 'ml Liquid Chlorine';
    doseCalcKey = 1;
  }

  // Initialize results object
  let results = {
    Info: "",
    Range: '',
    Dosage: '',
    Products: false,
    ExtraInfo: ''
  };

  // Process ORP value if provided
  if (ORP !== false && ORP !== '') {
    let yourResultIs = '';
    let classText = '';
    let dosageText = '';
    let products = '';

    if (ORP < 250) {
      dosageText = `<span class='addText'>Add </span> ${dosageCalc[poolDetails.poolVolume][0][doseCalcKey]} ${dosetype}`;
      ExtraInfo = "<br><small>Add Chlorine to your pool and re-test in 24-48 hours</small>";
      yourResultIs = "LOW";
      classText = 'lowText';
      products = "POOL103";
    } else if (ORP >= 250 && ORP < 500) {
      dosageText = `<span class='addText'>Add </span> ${dosageCalc[poolDetails.poolVolume][1][doseCalcKey]} ${dosetype}`;
      ExtraInfo = "<br><small>Add Chlorine to your pool and re-test in 24-48 hours</small>";
      yourResultIs = "LOW";
      classText = 'lowText';
      products = "POOL103";
    } else if (ORP >= 500 && ORP < 700) {
      dosageText = "No Action";
      classText = 'okText';
      yourResultIs = 'OK';
    } else if (ORP >= 700) {
      dosageText = 'Dilute water to bring down your sanitisation levels';
      classText = 'highText';
      yourResultIs = 'HIGH';
    }

    results = {
      Info: `<b>Your sanitisation levels are <span class='${classText}'>${yourResultIs}</span> - ${ORP} mV</b> ${idealRangeText.ORP}`,
      Range: '500-700 mV',
      Dosage: dosageText,
      ExtraInfo: ExtraInfo,
      Products: products
    };
  }

  // Process FreeChlorine value if provided
  if (FreeChlorine !== false && FreeChlorine !== '') {
    let yourResultIs = '';
    let classText = '';
    let dosageText = '';
    let products = '';

    if (FreeChlorine < 0.5) {
      dosageText = `<span class='addText'>Add </span> ${dosageCalc[poolDetails.poolVolume][0][doseCalcKey]} ${dosetype}`;
      ExtraInfo = "<br><small>Add Chlorine to your pool and re-test in 24-48 hours</small>";
      classText = 'lowText';
      yourResultIs = "LOW";
      products = "POOL103";
    } else if (FreeChlorine >= 0.5 && FreeChlorine < 1) {
      dosageText = `<span class='addText'>Add </span> ${dosageCalc[poolDetails.poolVolume][1][doseCalcKey]} ${dosetype}`;
      ExtraInfo = "<br><small>Add Chlorine to your pool and re-test in 24-48 hours</small>";
      classText = 'lowText';
      yourResultIs = "LOW";
      products = "POOL103";
    } else if (FreeChlorine >= 1 && FreeChlorine <= 3) {
      dosageText = "No Action";
      classText = 'okText';
      yourResultIs = 'OK';
    } else if (FreeChlorine >= 3.5) {
      dosageText = 'Dilute water to bring down Free Chlorine Values';
      classText = 'highText';
      yourResultIs = 'HIGH';
    }

    results = {
      Info: `<b>Your Free Chlorine levels are <span class='${classText}'>${yourResultIs}</span> - ${FreeChlorine} ppm</b> ${idealRangeText.PPM}`,
      Range: '1 - 3 ppm',
      Dosage: dosageText,
      ExtraInfo: ExtraInfo,
      Products: products
    };
  }

  return results;
}


function calcPH(poolVolume, currentLevel, requiredLevel = 7.4) {
  // Determine pool size category
  let poolSize;
  if (poolVolume >= 1000 && poolVolume <= 1500) {
    poolSize = 0;
  } else if (poolVolume >= 10000 && poolVolume <= 20000) {
    poolSize = 1;
  } else if (poolVolume > 20000 && poolVolume <= 40000) {
    poolSize = 2;
  } else if (poolVolume > 40000 && poolVolume <= 70000) {
    poolSize = 3;
  } else if (poolVolume > 70000 && poolVolume <= 100000) {
    poolSize = 4;
  } else if (poolVolume > 100000) {
    poolSize = 5;
  }

  // Dosage calculations
  const dosageCalc = [
    ['6g', '11g', '23g'],
    ['60g', '115g', '230g'],
    ['115g', '230g', '340g'],
    ['230g', '455g', '680g'],
    ['445g', '910g', '1040g'],
    ['445g', '910g', '1040g']
  ];

  const idealRangeText = "Ideal Range is 7.2 - 7.6";
  let results = {
    Info: "",
    Range: '7.2 - 7.6',
    Dosage: '',
    Products: false,
    Class: ''
  };

  currentLevel = parseFloat(currentLevel);

  // pH is in ideal range
  if (currentLevel >= 7.2 && currentLevel <= 7.6) {
    let dosage = 'No Action';
    if (currentLevel === 7.2) {
      dosage = 'You may want to recheck soon as your pH is on the low limit of ideal';
    } else if (currentLevel === 7.6) {
      dosage = 'You may want to recheck soon as your pH is on the high limit of ideal';
    }

    results = {
      Info: `Your pH levels are <span class="okText">OK</span> - ${currentLevel} <br><b><small> (${idealRangeText})</small></b>`,
      Range: '7.2 - 7.6',
      Dosage: dosage,
      Products: false,
      Class: 'ok'
    };
    return results;
  }

  // pH is high - use pH Decreaser
  if (currentLevel > 7.6) {
    let dosageIndex;
    if (currentLevel >= 6.8) {
      dosageIndex = 0;
    } else if (currentLevel >= 6.5) {
      dosageIndex = 1;
    } else {
      dosageIndex = 2;
    }

    results = {
      Info: `Your pH is <span class="highText">HIGH</span> - ${currentLevel} <br><b><small> (${idealRangeText})</small></b>`,
      Range: '7.2 - 7.6',
      Dosage: `Add ${dosageCalc[poolSize][dosageIndex]} pH Decreaser`,
      ExtraInfo: 'Your water is too alkaline - decrease the pH by adding the recommended dosage of pH Down to your pool and re-test in 24-48 hours',
      Products: "POOL101",
      Class: 'high'
    };
    return results;
  }

  // pH is low - use pH Increaser
  if (currentLevel < 7.2) {
    let dosageIndex;
    if (currentLevel >= 6.8) {
      dosageIndex = 0;
    } else if (currentLevel >= 6.5) {
      dosageIndex = 1;
    } else {
      dosageIndex = 2;
    }

    const product = dosageIndex === 0 ? "POOL101" : "POOL100";

    results = {
      Info: `Your pH is <span class="lowText">LOW</span> - ${currentLevel} <br><b><small> (${idealRangeText})</small></b>`,
      Range: '7.2 - 7.6',
      Dosage: `Add ${dosageCalc[poolSize][dosageIndex]} pH Increaser`,
      ExtraInfo: 'Your water is too acidic - increase the pH by adding the recommended dosage of pH Up to your pool and re-test in 24-48 hours',
      Products: product,
      Class: 'low'
    };
    return results;
  }

  return results;
}

function calcSalt(poolVolume, currentSalt, requiredSaltLevel = 3000) {
  currentSalt = parseInt(currentSalt);
  poolVolume = parseInt(poolVolume);

  const idealRangeText = "Ideal Range is 3000 - 5000 ppm";
  let results = {
    Info: "",
    Range: '3000 - 5000',
    Dosage: '',
    Products: false,
    Class: ''
  };

  // Salt is in ideal range
  if (currentSalt >= 3000 && currentSalt <= 5000) {
    results = {
      Info: `Salt is <span class="okText">OK</span> - ${currentSalt} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '3000 - 5000',
      Dosage: "No Action",
      Class: 'ok'
    };
    return results;
  }

  // Salt is low
  if (currentSalt < 3000) {
    const saltDifference = requiredSaltLevel - currentSalt;
    const raisePPM = saltDifference / 1000;
    const saltRequired = raisePPM * (poolVolume / 10000 * 10);
    let saltRequiredKG = Math.round(saltRequired);
    let saltBags = Math.round(saltRequired / 20);

    if (saltBags < 1) saltBags = 1;

    results = {
      Info: `Salt is <span class="lowText">LOW</span> - ${currentSalt} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '3000 - 5000',
      Dosage: `Add ${saltBags} x 20KG bag${saltBags > 1 ? 's' : ''} of Salt`,
      ExtraInfo: 'Ideal range of Salt is required to be converted to chlorine by your Chlorinator. Add the required salt to your pool and re-test in 24-48 hours',
      Products: "POOL103",
      Class: 'low'
    };
    return results;
  }

  // Salt is high
  results = {
    Info: `Salt is <span class="highText">HIGH</span> - ${currentSalt} ppm <br><b><small> (${idealRangeText})</small></b>`,
    Range: '3000 - 5000',
    Dosage: "Add water to dilute the salt content or turn down your chlorinator",
    ExtraInfo: 'Add water to dilute the salt content or turn down your chlorinator to suit high salt',
    Products: false,
    Class: 'high'
  };
  return results;
}

function calcHardness(poolDetails, currentLevel) {
  if (!poolDetails || !poolDetails.poolVolume || !poolDetails.chlorineType) {
    return false;
  }

  const dosageCalc = {
    1000: { '0': '2.24KG', '100': '1.12KG' },
    10000: { '0': '2.24KG', '100': '1.12KG' },
    20000: { '0': '4.48KG', '100': '2.24KG' },
    30000: { '0': '6.72KG', '100': '3.36KG' },
    40000: { '0': '8.96KG', '100': '4.48KG' },
    50000: { '0': '11.2KG', '100': '5.6KG' },
    60000: { '0': '13.4KG', '100': '6.72KG' },
    70000: { '0': '15.68KG', '100': '7.84KG' },
    80000: { '0': '17.92KG', '100': '8.96KG' },
    90000: { '0': '20.16KG', '100': '10.08KG' },
    100000: { '0': '22.4KG', '100': '11.2KG' }
  };

  if (!dosageCalc[poolDetails.poolVolume]) {
    return false;
  }

  const idealRangeText = "Ideal Range is 250 - 500 ppm";
  let results = {
    Info: "",
    Range: '250-500',
    Dosage: '',
    Products: false,
    Class: ''
  };

  currentLevel = parseInt(currentLevel);

  if (currentLevel === 0 || currentLevel === 100) {
    const dosageKey = currentLevel === 0 ? '0' : '100';
    results = {
      Info: `Your Total Hardness levels are <span class="lowText">LOW</span> - ${currentLevel} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '250-500',
      Dosage: `Add ${dosageCalc[poolDetails.poolVolume][dosageKey]} Calcium Up`,
      Products: false,
      Class: 'low'
    };
  } else if (currentLevel >= 250 && currentLevel <= 500) {
    results = {
      Info: `Your Total Hardness levels are <span class="okText">OK</span> - ${currentLevel} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '250-500',
      Dosage: 'No Action',
      Products: false,
      Class: 'ok'
    };
  } else if (currentLevel > 500) {
    results = {
      Info: `Your Total Hardness levels are <span class="highText">HIGH</span> - ${currentLevel} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '250-500',
      Dosage: 'Dilute water to reduce hardness',
      Products: false,
      Class: 'high'
    };
  }

  return results;
}

function calcAlkalinity(poolDetails, currentLevel) {
  if (!poolDetails || !poolDetails.poolVolume || !poolDetails.chlorineType) {
    return false;
  }

  const dosageCalc = {
    1000: { '0': '1500g', '40': '1000g', '180': '1200g', '240': '2100g' },
    10000: { '0': '1500g', '40': '1000g', '180': '1200g', '240': '2100g' },
    20000: { '0': '3000g', '40': '2000g', '180': '2400g', '240': '4200g' },
    30000: { '0': '4000g', '40': '3000g', '180': '3600g', '240': '6300g' },
    40000: { '0': '5000g', '40': '4000g', '180': '4800g', '240': '8400g' },
    50000: { '0': '7000g', '40': '5000g', '180': '6000g', '240': '10500g' },
    60000: { '0': '8000g', '40': '6000g', '180': '7200g', '240': '12600g' },
    70000: { '0': '9000g', '40': '7000g', '180': '8400g', '240': '14700g' },
    80000: { '0': '10000g', '40': '8000g', '180': '9600g', '240': '16800g' },
    90000: { '0': '12000g', '40': '9000g', '180': '10800g', '240': '18900g' },
    100000: { '0': '13000g', '40': '10000g', '180': '12000g', '240': '2100g' }
  };

  if (!dosageCalc[poolDetails.poolVolume]) {
    return false;
  }

  const idealRangeText = "Ideal Range is 80 - 120 ppm";
  let results = {
    Info: "",
    Range: '80 - 120',
    Dosage: '',
    Products: false,
    Class: ''
  };

  currentLevel = parseInt(currentLevel);

  if (currentLevel === 0 || currentLevel === 40) {
    results = {
      Info: `Your Alkalinity levels are <span class="lowText">LOW</span> - ${currentLevel} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '80 - 120',
      Dosage: `Add ${dosageCalc[poolDetails.poolVolume][currentLevel]} Alkalinity Up`,
      Products: "POOL102",
      Class: 'low'
    };
  } else if (currentLevel === 80 || currentLevel === 120) {
    results = {
      Info: `Your Alkalinity levels are <span class="okText">OK</span> - ${currentLevel} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '80 - 120',
      Dosage: 'No Action',
      Products: false,
      Class: 'ok'
    };
  } else if (currentLevel === 180 || currentLevel === 240) {
    results = {
      Info: `Your Alkalinity levels are <span class="highText">HIGH</span> - ${currentLevel} ppm <br><b><small> (${idealRangeText})</small></b>`,
      Range: '80 - 120',
      Dosage: `Add ${dosageCalc[poolDetails.poolVolume][currentLevel]} Alkalinity Down`,
      Products: false,
      Class: 'high'
    };
  }

  return results;
}